import { JsonProperty, JsonObject, Any } from 'json2typescript';
import { Product } from '@hermes/api-model-product';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * This class describe a capa feasibility request
 *
 * @dynamic
 */
let CapaFeasibilityRequest = class CapaFeasibilityRequest {
    constructor(source) {
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("locale", String, true),
    __metadata("design:type", String)
], CapaFeasibilityRequest.prototype, "locale", void 0);
__decorate([
    JsonProperty("SKU", String, true),
    __metadata("design:type", String)
], CapaFeasibilityRequest.prototype, "sku", void 0);
__decorate([
    JsonProperty("timestamp", String, true),
    __metadata("design:type", String)
], CapaFeasibilityRequest.prototype, "timestamp", void 0);
__decorate([
    JsonProperty("Perso", String, true),
    __metadata("design:type", String)
], CapaFeasibilityRequest.prototype, "perso", void 0);
__decorate([
    JsonProperty("idmagento", String, true),
    __metadata("design:type", String)
], CapaFeasibilityRequest.prototype, "idMagento", void 0);
__decorate([
    JsonProperty("dku", String, true),
    __metadata("design:type", String)
], CapaFeasibilityRequest.prototype, "dku", void 0);
CapaFeasibilityRequest = __decorate([
    JsonObject("CapaFeasibilityRequest"),
    __metadata("design:paramtypes", [Object])
], CapaFeasibilityRequest);

/**
 * This class describe a capa feasibility response
 */
let CapaFeasibilityResponse = class CapaFeasibilityResponse {
    constructor() {
        this.error = undefined;
        this.status = undefined;
    }
};
__decorate([
    JsonProperty("error", Any, true),
    __metadata("design:type", Object)
], CapaFeasibilityResponse.prototype, "error", void 0);
__decorate([
    JsonProperty("status", Boolean, true),
    __metadata("design:type", Boolean)
], CapaFeasibilityResponse.prototype, "status", void 0);
CapaFeasibilityResponse = __decorate([
    JsonObject("CapaFeasibilityResponse")
], CapaFeasibilityResponse);

/**
 * This class describe an assets
 * It's used to send a list of personalized images
 */
let PersonalizationAsset = class PersonalizationAsset {
};
__decorate([
    JsonProperty("url", String, true),
    __metadata("design:type", String)
], PersonalizationAsset.prototype, "url", void 0);
__decorate([
    JsonProperty("face", String, true),
    __metadata("design:type", String)
], PersonalizationAsset.prototype, "face", void 0);
__decorate([
    JsonProperty("customized", Boolean, true),
    __metadata("design:type", Boolean)
], PersonalizationAsset.prototype, "customized", void 0);
PersonalizationAsset = __decorate([
    JsonObject("PersonalizationAsset")
], PersonalizationAsset);

/**
 * This class describe an email request
 */
let EmailPersonalizationRequest = class EmailPersonalizationRequest {
};
__decorate([
    JsonProperty("dku", String, true),
    __metadata("design:type", String)
], EmailPersonalizationRequest.prototype, "dku", void 0);
__decorate([
    JsonProperty("url", String, true),
    __metadata("design:type", String)
], EmailPersonalizationRequest.prototype, "url", void 0);
__decorate([
    JsonProperty("product", Product, true),
    __metadata("design:type", Product)
], EmailPersonalizationRequest.prototype, "product", void 0);
__decorate([
    JsonProperty("locale", String, true),
    __metadata("design:type", String)
], EmailPersonalizationRequest.prototype, "locale", void 0);
__decorate([
    JsonProperty("email", String, true),
    __metadata("design:type", String)
], EmailPersonalizationRequest.prototype, "email", void 0);
__decorate([
    JsonProperty("picture", [PersonalizationAsset], true),
    __metadata("design:type", Array)
], EmailPersonalizationRequest.prototype, "picture", void 0);
EmailPersonalizationRequest = __decorate([
    JsonObject("EmailPersonalizationRequest")
], EmailPersonalizationRequest);

/**
 * This class describe an email response
 */
let EmailPersonalizationResponse = class EmailPersonalizationResponse {
    constructor() {
        this.error = undefined;
    }
};
__decorate([
    JsonProperty("error", Any, true),
    __metadata("design:type", Object)
], EmailPersonalizationResponse.prototype, "error", void 0);
EmailPersonalizationResponse = __decorate([
    JsonObject("EmailPersonalizationResponse")
], EmailPersonalizationResponse);

export { CapaFeasibilityRequest, CapaFeasibilityResponse, EmailPersonalizationRequest, EmailPersonalizationResponse, PersonalizationAsset };
